import { render, staticRenderFns } from "./follow-store.vue?vue&type=template&id=580e551c&scoped=true"
import script from "./follow-store.vue?vue&type=script&lang=js"
export * from "./follow-store.vue?vue&type=script&lang=js"
import style0 from "./follow-store.vue?vue&type=style&index=0&id=580e551c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e551c",
  null
  
)

export default component.exports